/**
 * rt-nav-click — desktop header dropdowns.
 *
 * Abrem por hover; clique abre (touch/teclado); fecham ao sair, Escape ou clique fora.
 *
 * Broadcast's <hover-disclosure> wires mouseenter/mouseleave straight to
 * showDisclosure()/hideDisclosure() inside its own connectedCallback, with
 * anonymous handlers — there is nothing to removeEventListener. But those two
 * methods live on the instance, so overriding them per element turns the theme's
 * own handlers into no-ops without touching theme.js (a Broadcast base file, minified).
 *
 * The real methods are kept and called from our own hover and click handlers, so the
 * theme's classes, aria state and stagger animation all still run.
 *
 * Mobile is untouched: the drawer has its own component, and this only binds
 * inside .header__menu, which is desktop-only markup.
 */
(function () {
  var OPEN = 'is-visible';
  /**
   * .theme__header is a stacking context at z-index 2300 while the page sits at
   * the top, and 5600 once it sticks. The category strip is sticky at 5590, so
   * in the un-stuck state it paints OVER everything the header contains — the
   * open panel included, which swallowed its first row. Raising the header only
   * while a panel is open keeps the rest of the z ladder (strip 5590 · header
   * stuck 5600 · promo bar 5601 · drawers 6001) exactly as it was.
   */
  var NAV_OPEN = 'rt-nav-open';

  function init() {
    var items = document.querySelectorAll('.header__menu hover-disclosure');
    if (!items.length) return;

    var header = document.querySelector('.theme__header');
    var all = [];

    items.forEach(function (el) {
      var trigger = el.querySelector('[data-top-link]');
      if (!trigger || typeof el.showDisclosure !== 'function') return;

      var show = el.showDisclosure.bind(el);
      var hide = el.hideDisclosure.bind(el);

      // o tema abre/fecha por dentro (mouseenter/focusout) com handlers anónimos: ficam
      // no-op e somos nós a chamar show/hide, para a classe NAV_OPEN andar sempre junta.
      el.showDisclosure = function () {};
      el.hideDisclosure = function () {};

      var entry = {el: el, show: show, hide: hide};
      all.push(entry);

      function open() {
        clearTimeout(entry.t);
        if (el.classList.contains(OPEN)) return;
        closeAll();
        show();
        if (header) header.classList.add(NAV_OPEN);
      }

      function close() {
        clearTimeout(entry.t);
        hide();
        if (header && !document.querySelector('.header__menu hover-disclosure.' + OPEN)) header.classList.remove(NAV_OPEN);
      }

      // hover: abre ao entrar; ao sair espera 150ms, para a diagonal até ao painel não o fechar
      el.addEventListener('mouseenter', open);
      el.addEventListener('mouseleave', function () {
        clearTimeout(entry.t);
        entry.t = setTimeout(close, 150);
      });

      // o focusout do tema ficou no-op com o hideDisclosure: fechar quando o foco sai do painel.
      // relatedTarget null com o rato por cima (clique em zona nao focavel, troca de janela) nao fecha:
      // o mouseleave trata disso.
      el.addEventListener('focusout', function (e) {
        if (el.classList.contains(OPEN) && !el.contains(e.relatedTarget) && !el.matches(':hover')) close();
      });

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open();
      });

      // a click inside the panel is a real link — let it through
      el.querySelectorAll('.header__dropdown a').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });
    });

    function closeAll() {
      all.forEach(function (entry) {
        clearTimeout(entry.t);
        if (entry.el.classList.contains(OPEN)) entry.hide();
      });
      if (header) header.classList.remove(NAV_OPEN);
    }

    // clique fora fecha; dentro do painel aberto (zona sem link) nao
    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element && e.target.closest('.header__menu hover-disclosure.' + OPEN))) closeAll();
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  // the custom element upgrades on DOMContentLoaded; wait for it or the
  // showDisclosure override lands on a plain HTMLElement and does nothing.
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('hover-disclosure').then(init);
  } else if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
